export default __webpack_public_path__ + "static/media/pot2.634c87ec.svg";